import { useQuery } from '@tanstack/react-query';

import { getBusinessEntityList } from '~apis/business-entity';

export const BusinessEntityQueryKey = {
  default: ['USE_GET_BUSINESS_ENTITY_LIST'],
  list: ({ companyId, favoriteOnly }: { companyId: string; favoriteOnly: boolean }) => [
    ...BusinessEntityQueryKey.default,
    companyId,
    favoriteOnly,
  ],
  search: ({ companyId, searchParam }: { companyId: string; searchParam: string }) => [
    ...BusinessEntityQueryKey.default,
    companyId,
    searchParam,
  ],
};

export default function useBusinessEntityListQuery({
  companyId,
  favoriteOnly,
}: {
  companyId: string;
  favoriteOnly: boolean;
}) {
  return useQuery(
    BusinessEntityQueryKey.list({ companyId, favoriteOnly }),
    () =>
      getBusinessEntityList({
        companyId,
        favoriteOnly,
      }),
    {
      enabled: !!companyId,
    },
  );
}
